import { Box, SvgIcon } from '@mui/material';
import { yellow } from '@mui/material/colors';

export const IssueIcon = (props) => {
  return (
    <Box
      sx={{
        width: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 20,
        backgroundColor: yellow[200],
        borderRadius: '50%',
        cursor: 'default',
      }}
    >
      <SvgIcon {...props}>
        <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.0001 6.62497V8.45831M8.0001 10.2916H8.00468M7.21635 4.26914L3.33427 10.75C3.25423 10.8886 3.21188 11.0457 3.21143 11.2058C3.21098 11.3659 3.25245 11.5232 3.33171 11.6623C3.41098 11.8014 3.52527 11.9172 3.66322 11.9984C3.80117 12.0796 3.95797 12.1232 4.11802 12.125H11.8822C12.0422 12.1232 12.199 12.0796 12.337 11.9984C12.4749 11.9172 12.5892 11.8014 12.6685 11.6623C12.7478 11.5232 12.7892 11.3659 12.7888 11.2058C12.7883 11.0457 12.746 10.8886 12.6659 10.75L8.78385 4.26914C8.70214 4.13444 8.5871 4.02307 8.44982 3.94578C8.31253 3.86849 8.15765 3.82788 8.0001 3.82788C7.84256 3.82788 7.68767 3.86849 7.55039 3.94578C7.4131 4.02307 7.29806 4.13444 7.21635 4.26914Z"
            stroke={yellow[900]}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </SvgIcon>
    </Box>
  );
};
